import mobile from 'is-mobile';
/* eslint-disable-next-line owa-custom-rules/forbid-svg-import -- (https://aka.ms/OWALintWiki)
 * BASELINE: DO NOT COPY/PASTE! UNVERIFIED-SVG-DISABLE: confirm no @fluentui/react-icons component exists for this asset and a direct SVG import is truly required. If confirmed, replace this comment with "Direct SVG import required; component-based icon (@fluentui/react-icons) not available for this asset". If an icon replacement is possible, migrate to it and remove the import and this disable
 *	> Referencing SVG files that are available as Fluent v9 icons is forbidden. Use the corresponding Fluent v9 icon instead. Browse available icons in the Fluent UI documentation: https://storybooks.fluentui.dev/react/?path=/docs/fluent-system-icons_icons-catalog--docs */
import microsoftPlacesLogo from 'owa-appbar-icons/lib/microsoftPlaces.svg';
import { isRunningInMetaOSHub } from 'owa-config';
import { observer } from 'owa-mobx-react';
import { PLACES_BRANDING_NAME } from 'places-common-strings';
import React from 'react';
import { Link, Subtitle1, Subtitle2 } from '@fluentui/react-components';
import { logo, logoIcon, logoIconMetaOS } from './HybridspaceLogo.scss';

const defaultExport: React.FunctionComponent<{}> = observer(function HybridspaceLogo() {
    const title = PLACES_BRANDING_NAME;
    const id = 'PlacesLogo';

    const onClick = React.useCallback(() => {
        window.location.reload();
    }, []);

    const isRunningInMetaOS = isRunningInMetaOSHub();
    const isMobile = mobile();

    return (
        <Link className={logo} data-telemetry-id={id} onClick={onClick} appearance="subtle">
            <img
                className={isRunningInMetaOS ? logoIconMetaOS : logoIcon}
                src={microsoftPlacesLogo}
                aria-label={title}
            />
            {isRunningInMetaOS ? (
                !isMobile && <Subtitle2>{title}</Subtitle2>
            ) : (
                <Subtitle1>{title}</Subtitle1>
            )}
        </Link>
    );
}, 'HybridspaceLogo');
export default defaultExport;
